



































































































































import { default as Component } from 'vue-class-component';

import RulesWidget from '@/components/widgets/RulesWidget.vue';
import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';
import HsgShowCompletedData from '@/components/widgets/hsg/HsgShowCompletedData.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Api from '@/interfaces/Api';
import Tracking from '@/interfaces/Tracking';
import SessionState from '@/interfaces/SessionState';
import SubmitButton from '@/components/widgets/SubmitButton.vue';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  props: {
    isCompleted: Boolean,
    errorOrderCreated: Object,
    isMobile: Boolean,
    inCreation: Boolean
  },
  components: {
    'messages-block': MessagesBlock,
    'show-completed-data': HsgShowCompletedData,
    SubmitButton
  }
})
export default class HsgRulesWidget extends RulesWidget {
  public adsAccepted = false;
  public termsAccepted = false;
  public termsAcceptedError = false;

  get dataReview(): SessionState {
    return this.store.getters.getSession;
  }

  get isErrorPermissionToTerminateContract(): boolean {
    return (
      typeof this.errorPermissionToTerminateContract !== 'undefined' && this.errorPermissionToTerminateContract !== null
    );
  }
  get errorPermissionToTerminateContract(): { key: string; message: string }[] | null {
    return this.getHsgError('permissionToTerminateContract');
  }

  get isErrorTandcs(): boolean {
    return typeof this.errorTandcs !== 'undefined' && this.errorTandcs !== null;
  }
  get errorTandcs(): { key: string; message: string }[] | null {
    return this.getHsgError('tandcs');
  }

  get isErrorPrivacy(): boolean {
    return typeof this.errorPrivacy !== 'undefined' && this.errorPrivacy !== null;
  }
  get errorPrivacy(): { key: string; message: string }[] | null {
    return this.getHsgError('privacy');
  }

  public getHsgError(fieldName: string): [{ key: string; message: string }] | null {
    if (!this.errorsBag) {
      return null;
    }
    return typeof this.errorsBag[fieldName] === 'object' ? this.errorsBag[fieldName] : null;
  }

  public rulesSubmit(): Promise<void> | void {
    this.errorsBag = null;
    this.termsAcceptedError = false;

    if (!this.termsAccepted) {
      this.termsAcceptedError = true;
      return;
    }

    // if (!this.rulesData.permissionToTerminateContract) {
    //   this.setErrorsBag(
    //     'permissionToTerminateContract',
    //     'rules.widget.permission.to.terminate.contract.required.error',
    //     this.$t('rules.widget.permission.to.terminate.contract.required.error').toLocaleString()
    //   );
    // }

    // if (!this.rulesData.tandcs) {
    //   this.setErrorsBag('tandcs', 'rules.widget.error1', this.$t('rules.widget.error1').toLocaleString());
    // }
    //
    // if (!this.rulesData.privacy) {
    //   this.setErrorsBag('privacy', 'rules.widget.error3', this.$t('rules.widget.error3').toLocaleString());
    // }

    // if (this.rulesData.tandcs && this.rulesData.privacy) {
    return ApiProvider.sessionUpdate(this.rulesData)
      .then(() => {
        ApiProvider.validateRules()
          .then(() => {
            this.store.commit('SET_SESSION', this.rulesData);
            trackingProvider.validationRulesSuccessful(this.sessionState, this.$props.product);
            this.$emit('rulesSubmit', this.rulesData);
          })
          .catch((error) => {
            trackingProvider.validationRulesFailed();
            if (error.response.data && typeof error.response.data.error !== 'undefined') {
              this.errorsBag = error.response.data.error.messages;
            }
          });
      })
      .catch((error) => {
        if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
          localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
          window.location.href = document.referrer || window.location.origin;
        }
      });
    // }
  }

  public choiceMethodChanged(choice: string): void {
    switch (choice) {
      case 'call':
        if (this.rulesData.adsPhone) {
          this.rulesData.adsPhone = false;
        }
        break;
      case 'email':
        if (this.rulesData.adsMail) {
          this.rulesData.adsMail = false;
        }
        break;
      case 'letter':
        if (this.rulesData.adsPost) {
          this.rulesData.adsPost = false;
        }
        break;
      case 'terms':
        if (this.rulesData.tandcs) {
          this.rulesData.tandcs = false;
        }
        break;
      case 'protection':
        if (this.rulesData.privacy) {
          this.rulesData.privacy = false;
        }
        break;
      case 'terminate':
        if (this.rulesData.permissionToTerminateContract) {
          this.rulesData.permissionToTerminateContract = false;
        }
        break;
      case 'ads':
        if (this.adsAccepted) {
          this.adsAccepted = false;
        }
        break;
    }
  }

  private setErrorsBag(errorKey: string, localeKey: string, message: string) {
    if (typeof this.errorsBag === 'undefined' || this.errorsBag === null) {
      this.errorsBag = {
        [errorKey]: [
          {
            key: localeKey,
            message
          }
        ]
      };
    } else {
      this.errorsBag[errorKey] = [
        {
          key: localeKey,
          message
        }
      ];
    }
  }
}
